/** Spaces per page; must match the `limit` sent to spaces-v2. */
export const PAGE_SIZE = 10;

/** NUX experience shown once the host's experiences first resolve. */
export const NEW_BADGE_EXPERIENCE = "mylistings-new-badge";

export const EDIT_PRICE_EXPERIENCE = "edit-price-tooltip";

export const MANAGE_ADDONS_EXPERIENCE = "manage-addons-tooltip";
